module.exports = __webpack_public_path__ + "static/media/brand-refresh-field-error-info.29dfe404.svg";